import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { setDesignSystemSearchQuery } from 'redux/mode/actions';
import Icon, { IconType } from 'components/Icon';
import * as S from './SearchBar/styles';

interface SearchBarProps {
	section: 'tokens' | 'styles' | 'components' | 'stories';
	placeholder?: string;
}

const SearchBar = ({ section, placeholder = 'Search...' }: SearchBarProps) => {
	const dispatch = useDispatch();
	const searchQuery = useSelector(
		(r: RootReducer) => r.mode.designSystemFilters[section].searchQuery
	);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(setDesignSystemSearchQuery({ section, query: e.target.value }));
	};

	const handleClear = () => {
		dispatch(setDesignSystemSearchQuery({ section, query: '' }));
	};

	return (
		<S.Container>
			<S.SearchIcon>
				<Icon type={IconType.SEARCH} width={16} height={16} />
			</S.SearchIcon>
			<S.Input type="text" placeholder={placeholder} value={searchQuery} onChange={handleChange} />
			{searchQuery && (
				<S.ClearButton onClick={handleClear} aria-label="Clear search">
					<Icon type={IconType.CLOSE} width={14} height={14} />
				</S.ClearButton>
			)}
		</S.Container>
	);
};

export default SearchBar;
